import { useState, type FormEvent } from 'react';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      form.reset();
      setTimeout(() => setStatus('idle'), 5000);
      return;
    }

    setStatus('loading');
    setErrorMessage('');

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt' && value) {
          payload.append(key, value.toString());
        }
      });

      const response = await fetch('http://dollydiy.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      const code = typeof parsed?.code === 'string' ? parsed.code : '';
      const serverMsg = typeof parsed?.meta === 'object' && parsed?.meta !== null
        ? (parsed.meta as Record<string, unknown>).message
        : typeof parsed?.message === 'string' ? parsed.message : '';

      if (response.ok && code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试';
        setErrorMessage(msg);
        setStatus('error');
      }
    } catch {
      setErrorMessage('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section id="newsletter" className="relative py-14 md:py-16">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 via-accent-500/5 to-secondary-500/10"></div>
      <div className="relative mx-auto px-4 md:px-6 max-w-2xl text-center">
        <div className="w-12 h-12 mx-auto flex items-center justify-center mb-4">
          <i className="ri-mail-send-line text-3xl text-primary-500"></i>
        </div>
        <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-2">
          不想错过任何一个大瓜？
        </h3>
        <p className="text-foreground-500 text-sm mb-6">
          订阅吃瓜简报，每日新鲜大瓜第一时间送到你手上
        </p>

        <form
          id="newsletter-form"
         
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '订阅中...' : '立即订阅'}
          </button>

          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="absolute opacity-0 pointer-events-none w-0 h-0"
          />
        </form>

        {status === 'success' && (
          <p className="mt-3 text-sm text-green-600 font-medium">
            订阅成功！每日新鲜大瓜即将送达你的邮箱～
          </p>
        )}
        {status === 'error' && (
          <p className="mt-3 text-sm text-accent-600 font-medium">
            {errorMessage || '提交失败，请稍后再试'}
          </p>
        )}

        <p className="mt-3 text-xs text-foreground-400">
          我们尊重你的隐私，绝不发送垃圾邮件
        </p>
      </div>
    </section>
  );
}